export default __webpack_public_path__ + "static/media/home-creative-agency-img-04.7c106c7a.jpg";